import api from './api';
import ISettingsGet from './interfaces/common/ISettingsGet';
import IVersion from './interfaces/common/IVersion';

export default {
  settings: {
    get: async (): Promise<ISettingsGet> => api.get('/api/v1/settings'),
  },
  excelListTypes: {
    get: async (): Promise<string[]> => api.get('/api/v1/excel-list-types'),
  },
  version: {
    get: async (): Promise<IVersion> => api.get('/api/v1/version'),
  },
};
